import _ from 'underscore';
import { INotification, TargetComponent, NotificationLevel, DismissMode, ScopeLevel, IContext } from '../../types';
import { isBillingLinkPermission } from '../../utils';

export class BroadOnlyNotification {
  context: IContext;
  i18n: any;
  availableScopes: ScopeLevel[];

  constructor(context: IContext) {
    this.context = context;
    this.i18n = context.getNewI18n();
    this.availableScopes = [ScopeLevel.account, ScopeLevel.customer];
  }

  async getBroadOnlyNotifications() {
    if (!this.context.getUserContext().CurrentUser.IsInternal && isBillingLinkPermission(this.context.getSettingsContext())) {
      return [];
    }

    // const serverContext = this.context.getServerContext();
    // const isBroadOnlyEnabled = serverContext && serverContext.DynamicPermissions.BroadOnly;
    const isBroadOnlyEnabled = false;
    if (!isBroadOnlyEnabled) {
      return [];
    }

    const titleApproved = _TL_('We’ve approved your brand request for {{name}}');
    const titleNotApproved = _TL_('Your brand request for {{name}} was disapproved ');

    const messgeApproved = _TL_('Your brand request was approved and has been automatically added to your brand list. You can go to Tools > Brand lists to review and edit your shared library.');
    const messgeNotApproved = _TL_('The brand you requested wasn’t approved. To learn more about why your brand may have been disapproved, please see {{helpLinkStart}}[new help topic]{{helpLinkEnd}}.');

    const data = await this.getNotifications();

    // Get notifications
    const notifications: INotification[] = data.map(notification => ({
      id: `BroadOnlyNotification-${notification.Id}`,
      condition: true,
      target: TargetComponent.UnifiedQueue,
      dismissMode: DismissMode.session,
      severity: NotificationLevel.Info,
      scopeLevel: ScopeLevel.account,
      availableScopes: this.availableScopes,
      title: notification.Approved ? this.i18n.getString(titleApproved, { name: notification.Name }) : this.i18n.getString(titleNotApproved, { name: notification.Name }),
      message: notification.Approved ? this.i18n.getString(messgeApproved) : this.i18n.getString(messgeNotApproved, {
        helpLinkStart: '<a class="HelpTopic" href="#" role="button" aria-label="" query="help:app54850">',
        helpLinkEnd: '</a>',
      }),
      actionList: [],
    }));


    return _.compact(notifications);
  }

  async getNotifications() {
    await new Promise(resolve => setTimeout(resolve, 500));
    return [
      {
        Id: 1,
        Name: 'adida',
        Approved: true,
      },
      {
        Id: 2,
        Name: 'adida',
        Approved: false,
      },
    ];
  }
}
